import React from 'react';
import { Server } from 'lucide-react';
import { useScopeSystems } from '../../../hooks/analytics/useScopeReports.ts';
import { StatCard, WidgetCard } from '../controller/shared.tsx';

/** `scope_systems` — count of systems in scope. */
export const ScopeSystemsCard: React.FC = () => {
  const { data, isLoading, isError, error, dataUpdatedAt, isFetching, refetch } = useScopeSystems();

  return (
    <WidgetCard
      title="Systems in Scope"
      loading={isLoading}
      error={isError ? error : null}
      errorMessage={error?.message ?? 'Failed to load systems in scope.'}
      isEmpty={!isLoading && !isError && !data}
      updatedAt={dataUpdatedAt}
      onRefresh={refetch}
      isFetching={isFetching}
    >
      <StatCard
        title="Systems In Scope"
        value={data?.total ?? 0}
        icon={<Server className="h-5 w-5" />}
        color="bg-cyan-100 text-cyan-600"
        subtitle={
          data && data.systems.length > 0
            ? `${data.systems.slice(0, 3).map((s) => s.name).join(', ')}${data.systems.length > 3 ? '…' : ''}`
            : undefined
        }
      />
    </WidgetCard>
  );
};

export default ScopeSystemsCard;
